<template>
  <div class="row-wrapper">
    <div class="field-wrapper">
      <span class="input-label">Наименование выпуска</span>
      <el-input
        placeholder="Наименование выпуска"
        v-model="mutateClaim.title"
        @input="handleChange"
        class="fixed-width"
      />
    </div>

    <div class="field-wrapper">
      <span class="input-label">Тип</span>
      <el-select
        v-model="mutateClaim.type"
        placeholder="Тип"
        @input="handleChange"
        class="fixed-width"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        />
      </el-select>
    </div>

    <div class="field-wrapper">
      <span class="input-label">Время отображения Выпуска в системе</span>
      <el-date-picker
        v-model="showDateTimeUntil"
        type="datetimerange"
        @input="handleUntilRangeChange"
        placeholder="Время отображения на сайте"
      />
    </div>

    <div class="field-wrapper">
      <span class="input-label">Время начала / окончания сбора заявок</span>
      <el-date-picker
        v-model="showDateTime"
        type="datetimerange"
        @input="handleShowRangeChange"
        placeholder="Время начала и окончания"
      />
    </div>

    <div class="field-wrapper">
      <span class="input-label">Время для изменения заявки</span>
      <el-date-picker
        v-model="mutateClaim.claimUpdatingDateTime"
        type="datetime"
        @input="handleChange"
        placeholder="Время для изменения заявки"
      />
      <span class="input-label small-width">Позволять менять Брокера</span>
      <el-checkbox v-model="mutateClaim.isBrokerMutable" @input="handleChange" />
    </div>

    <div class="field-wrapper">
      <span class="input-label">Время сбора подтверждений</span>
      <el-date-picker
        v-model="proposalDateTime"
        type="datetimerange"
        @input="handleProposalRangeChange"
        placeholder="Время сбора подтверждений"
      />
    </div>

    <div class="field-wrapper">
      <span class="input-label">Количество</span>
      <div>
        <el-input-number
          :controls="false"
          v-model="mutateClaim.amountMin"
          @input="handleChange"
        />
        <el-input-number
          :controls="false"
          v-model="mutateClaim.amountMax"
          @input="handleChange"
        />
      </div>
    </div>

    <div class="field-wrapper">
      <span class="input-label">Предельная сумма</span>
      <el-input-number
        :controls="false"
        v-model="mutateClaim.maxSum"
        @input="handleChange"
      />
      <span class="input-label small-width">Кратность</span>
      <el-input-number
        :controls="false"
        v-model="mutateClaim.mult"
        @input="handleChange"
      />
    </div>

    <div class="field-wrapper">
      <span class="input-label">Цена</span>
      <div>
        <input
          type="number"
          class="float"
          v-model="mutateClaim.priceMin"
          @input="handleChange"
          @keypress="handleKeyPress"
        />
        <input
          type="number"
          class="float"
          v-model="mutateClaim.priceMax"
          @input="handleChange"
          @keypress="handleKeyPress"
        />
      </div>
      <span class="input-label small-width">Показывать символ "%"</span>
      <el-checkbox v-model="mutateClaim.showPercent" @input="handleChange" />
    </div>

    <div class="field-wrapper">
      <span class="input-label">Ставка</span>
      <div>
        <input
          type="number"
          class="float"
          v-model="mutateClaim.rateMin"
          @input="handleChange"
          @keypress="handleKeyPress"
        />
        <input
          type="number"
          class="float"
          v-model="mutateClaim.rateMax"
          @input="handleChange"
          @keypress="handleKeyPress"
        />
      </div>
      <span class="input-label small-width">Аллокация</span>
      <el-checkbox v-model="mutateClaim.allocation" @input="handleChange" />
    </div>

    <div class="field-wrapper">
      <span class="input-label">Только для квалифиц.</span>
      <el-checkbox
        name="qualified"
        v-model="mutateClaim.onlyForQualified"
        @input="handleChangeQualifiedTesting('qualified')"
      />
      <span class="input-label small-width">Требуется тестирование</span>
      <el-checkbox
        v-model="mutateClaim.testingRequired"
        @input="handleChangeQualifiedTesting('testing')"
      />
    </div>

    <span class="button-wrapper centered" @click="handleRemove">
      <a class="button is-danger">-</a>
      Удалить
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import deepcopy from 'deepcopy'

export default {
  name: 'Claim',
  data() {
    return {
      options: [
        {
          value: 'initial',
          label: 'Первичное размещение'
        },
        {
          value: 'buyout',
          label: 'Выкуп'
        }
      ]
    }
  },
  props: {
    claim: {
      type: Object,
      required: true
    }
  },
  computed: {
    mutateClaim() {
      return deepcopy(this.claim)
    }
  },
  created() {
    ;(this.showDateTime = [
      this.mutateClaim.showDateTimeMin,
      this.mutateClaim.showDateTimeMax
    ]),
      (this.showDateTimeUntil = [
        this.mutateClaim.showDateTimeUntilMin,
        this.mutateClaim.showDateTimeUntilMax
      ]),
      (this.proposalDateTime = [
        this.mutateClaim.proposalDateTimeMin,
        this.mutateClaim.proposalDateTimeMax
      ])
  },
  methods: {
    ...mapActions(['updateClaim', 'removeClaim']),
    handleChange() {
      this.updateClaim(deepcopy(this.mutateClaim))
      this.$forceUpdate()
    },
    handleKeyPress(e) {
      if (e.target.value.includes('.') || e.target.value.includes(',')) {
        const limit = /[.,]\d{2}/.test(e.target.value)
        if (limit) {
          e.preventDefault()
        }
      }
    },
    handleChangeQualifiedTesting(name) {
      if (name === 'qualified') {
        if (!this.mutateClaim.onlyForQualified) {
          this.mutateClaim.onlyForQualified = false
        } else {
          this.mutateClaim.onlyForQualified = true
          if (this.mutateClaim.testingRequired) {
            this.mutateClaim.testingRequired = false
          }
        }
      } else {
        if (!this.mutateClaim.testingRequired) {
          this.mutateClaim.testingRequired = false
        } else {
          this.mutateClaim.testingRequired = true
          if (this.mutateClaim.onlyForQualified) {
            this.mutateClaim.onlyForQualified = false
          }
        }
      }
      this.handleChange()
    },
    handleShowRangeChange() {
      this.mutateClaim.showDateTimeMin = this.showDateTime[0]
      this.mutateClaim.showDateTimeMax = this.showDateTime[1]
      this.handleChange()
    },
    handleUntilRangeChange() {
      this.mutateClaim.showDateTimeUntilMin = this.showDateTimeUntil[0]
      this.mutateClaim.showDateTimeUntilMax = this.showDateTimeUntil[1]
      this.handleChange()
    },
    handleProposalRangeChange() {
      this.mutateClaim.proposalDateTimeMin = this.proposalDateTime[0]
      this.mutateClaim.proposalDateTimeMax = this.proposalDateTime[1]
      this.handleChange()
    },
    handleRemove() {
      this.removeClaim(deepcopy(this.mutateClaim.id))
    }
  }
}
</script>
<style scoped>
.float {
  padding: 3px 10px;
  width: 70px;
  height: 36px;
  outline: 0;
  border: 1px solid #bfcbd9;
  border-radius: 4px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.float:focus {
  border-color: #20a0ff;
}
/* Chrome, Safari, Edge, Opera */
.float::-webkit-outer-spin-button,
.float::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
.float {
  -moz-appearance: textfield;
}
.el-date-editor {
  max-width: 100%;
}
.el-input-number {
  max-width: 70px;
}
.el-input:not(.el-date-editor) {
  width: max-content;
}
.field-wrapper {
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
}
.input-label {
  display: block;
  padding: 0 0.5rem;
  width: 140px;
}
.fixed-width {
  width: 220px !important;
}
.small-width {
  width: 120px;
  margin-left: 1rem;
}
.button-wrapper {
  margin: 30px 0;
}
.button.is-danger {
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// Claim.vue?27e4613e